import React from 'react';
import css from './style.scss';
import ReactDOM from 'react-dom';
import Confetti from 'react-confetti';
import Button from 'components/shared/button';

const SuccessPopup=(props)=>{
  let modalEl=document.getElementById("modals");
  return ReactDOM.createPortal(
    (
      <div className={css.successPopup}>
        <Confetti colors={["#E91E63"]} numberOfPieces={100} opacity={0.8} width={document.body.clientWidth} height={document.body.clientHeight} />
        <div className={css.successContainer}>
          <h2>Yess!</h2>
          <p>Congratulations, you are now a <b>{props.plan.name}</b> user!</p>
          <Button className={css.successReturn} onClick={()=>{if(props.onClose){props.onClose()}}} primary>Return to stori.social</Button>
        </div>
      </div>
    ),
    modalEl
  )
}

export default SuccessPopup;



// WEBPACK FOOTER //
// ./src/components/subscriptions/modal/ui/success_popup.js